import React, { useState, useEffect } from "react";
import useRazorpay from "react-razorpay";
import { Button, CircularProgress } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";

const CheckoutButton = ({
  user,
  amount,
  onCreateOrder,
  currentOrder,
  onPayment,
  disabled = false,
}) => {
  const [Razorpay] = useRazorpay();
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(false);

  const createOrder = async (order) => {
    setLoading(true);
    const url = "https://razorpayapi-nhcwp6ipsq-uc.a.run.app/createOrder";
    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(order),
        headers: {
          "content-type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }

      if (data.error) {
        throw new Error(data.error);
      }

      setOrderData(data);
    } catch (error) {
      setLoading(false);
      console.error("Order creation failed:", error);
      onPayment({
        success: false,
        error: error.message || "Failed to create order",
      });
    }
  };

  function handlePayment() {
    const options = {
      key:
        process.env.REACT_APP_PAYMENT_METHOD === "TEST"
          ? process.env.REACT_APP_RAZORPAY_KEY_TEST
          : process.env.REACT_APP_RAZORPAY_KEY_LIVE,
      amount: amount * 100,
      currency: "INR",
      name: "Apeksha Lifecare Products",
      description: "For Order " + (orderData !== null ? orderData.id : ""),
      order_id: orderData !== null ? orderData.id : "",
      handler: (response) => {
        onPayment({ success: true, response });
        setOrderData(null);
      },
      prefill: {
        name: user?.displayName || "",
        email: user?.email || "",
        contact: user?.mobile || "",
      },
      notes: {
        address: "Apeksha Lifecare Products, Haridwar, UK, INDIA",
      },
      theme: {
        color: process.env.REACT_APP_BG_COLOR || "#2f5d7e",
      },
      modal: {
        ondismiss: function () {
          console.log("Payment modal closed by the user.");
          try {
            if (typeof onPayment === "function") {
              onPayment({ success: false, dismissed: true });
            }
          } catch (e) {
            console.warn("Failed to notify onPayment dismissed:", e);
          }
          navigate("/userOrders");
        },
      },
    };
    const rzp1 = new Razorpay(options);

    rzp1.on("payment.failed", function (response) {
      setLoading(false);
      onPayment({ success: false, response });
    });
    rzp1.open();
  }

  useEffect(() => {
    if (orderData !== null && orderData !== undefined) {
      setLoading(false);
      onCreateOrder({ success: true, order: orderData });
    }
  }, [orderData]);

  useEffect(() => {
    if (currentOrder !== null && currentOrder !== undefined) {
      handlePayment();
    }
  }, [currentOrder]);

  return (
    <Button
      variant="contained"
      fullWidth
      startIcon={
        loading ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          <LockOutlinedIcon sx={{ fontSize: 18 }} />
        )
      }
      onClick={() => {
        createOrder({
          amount: amount * 100,
          receipt: "receipt_3",
          notes: { key1: "val1", key2: "val2" },
          currency: "INR",
          method: process.env.REACT_APP_PAYMENT_METHOD,
        });
      }}
      disabled={disabled || loading}
      sx={{
        py: 1.25,
        px: 3,
        borderRadius: "12px",
        fontWeight: 800,
        fontSize: "0.95rem",
        textTransform: "none",
        bgcolor: "primary.main",
        boxShadow: "0 4px 14px rgba(47, 93, 126, 0.35)",
        "&:hover": {
          bgcolor: "primary.dark",
          boxShadow: "0 6px 20px rgba(47, 93, 126, 0.45)",
        },
        "&.Mui-disabled": {
          bgcolor: "#e2e8f0",
          color: "#94a3b8",
        },
      }}
    >
      {loading ? "Preparing Payment..." : amount > 0 ? `Pay ₹${amount}` : "Pay Now"}
    </Button>
  );
};

export default CheckoutButton;
